const NAMESPACE_PREFIX = 'COUNTRIES'

export const COUNTRIES = {
    GET_COUNTRIES: `${NAMESPACE_PREFIX}.GET_COUNTRIES`,
    GET_COUNTRIES_SUCCESS: `${NAMESPACE_PREFIX}.GET_COUNTRIES_SUCCESS`,
    GET_COUNTRIES_FAILED: `${NAMESPACE_PREFIX}.GET_COUNTRIES_FAILED`,
}
